<template>
    <div class="base_box">
        <baseSearch @search="searchFun" :list="searchFrom" :searchData="search.post">
        </baseSearch>
        <div class="mt10 base_content">
            <baseTable :loading="search.loading" :total="search.total" :page="search.post.page" :list="search.table"
                :tableList="search.tableForm" :pagesize="search.post.limit" @changePage="handlePageChange">
                <template #vote_type="scope">
                    <span>{{ getVoteTypeText(scope.row.vote_type) }}</span>
                </template>
                <template #gift_info="scope">
                    <span v-if="scope.row.gift_name">{{ scope.row.gift_name }} ({{ scope.row.points }}积分)</span>
                    <span v-else>-</span>
                </template>
            </baseTable>
        </div>
    </div>
</template>
<script>
    import baseTable from "@/components/common/baseTable.vue"
    import baseSearch from "@/components/common/baseSearch.vue"

    export default {
        name: 'VoteLogList',
        components: {
            baseTable, baseSearch
        },
        data() {
            return {
                search: {
                    post: {
                        page: 1,
                        limit: 10,
                        competition_id: '',
                        competition_title: '',
                        contestant_keyword: '',
                        voter_keyword: '',
                        vote_type: '',
                        gift_id: '',
                        start_time: '',
                        end_time: ''
                    },
                    loading: false,
                    total: 0,
                    tableForm: [
                        { label: 'ID', prop: 'id', width: 100 },
                        { label: '活动名称', prop: 'competition_title', width: 260 },
                        { label: '投票人', prop: 'voter_nick_name', width: 200 },
                        { label: '投票人手机号', prop: 'voter_mobile', width: 160 },
                        { label: '选手昵称', prop: 'contestant_nick_name', width: 120 },
                        { label: '选手报名昵称', prop: 'contestant_sign_nickname', width: 180 },
                        { label: '投票类型', prop: 'vote_type', width: 160 },
                        { label: '投票数', prop: 'vote_num', width: 120 },
                        { label: '礼物信息', prop: 'gift_info', width: 180 },
                        { label: '投票时间', prop: 'created_at', width: 200 }
                    ],
                    table: []
                },
                searchFrom: [
                    {
                        type: "input",
                        Field: "competition_title",
                        label: "活动名称",
                        placeholder: "请输入活动名称",
                        style: { width: '160px' }
                    },
                    {
                        type: "input",
                        Field: "contestant_keyword",
                        label: "选手",
                        placeholder: "昵称/手机号",
                        style: { width: '150px' }
                    },
                    {
                        type: "input",
                        Field: "voter_keyword",
                        label: "投票人",
                        placeholder: "昵称/手机号",
                        style: { width: '150px' }
                    },
                    {
                        type: "select",
                        Field: "vote_type",
                        label: "投票方式",
                        placeholder: "全部",
                        style: { width: '120px' },
                        options: [
                            { label: '全部', value: '' },
                            { label: '每日免费', value: 1 },
                            { label: '广告投票', value: 2 },
                            { label: '礼物投票', value: 3 }
                        ]
                    },
                    {
                        type: "datetime",
                        Field: "start_time",
                        label: "开始时间",
                        style: { width: '160px' }
                    },
                    {
                        type: "datetime",
                        Field: "end_time",
                        label: "结束时间",
                        style: { width: '160px' }
                    }
                ]
            }
        },
        mounted() {
            // 获取URL参数中的活动ID
            const competitionId = this.$route.query.competition_id
            if (competitionId) {
                this.search.post.competition_id = competitionId
                console.log('活动ID:', competitionId)
            }
            this.searchFun()
        },
        methods: {
            searchFun(searchData) {
                const _this = this
                // 如果有传递搜索数据，则更新到搜索参数
                if (searchData) {
                    Object.assign(_this.search.post, searchData)
                    // 重置页码为1
                    _this.search.post.page = 1
                }
                _this.search.loading = true
                _this.axios.get('/api/sing/admin/vote-log/list', { params: _this.search.post }).then(res => {
                    if (res.code == 200) {
                        _this.search.table = res.data.list || []
                        _this.search.total = res.data.total || 0
                    }
                    _this.search.loading = false
                }).catch(() => {
                    _this.search.loading = false
                })
            },
            handlePageChange(val) {
                this.search.post.page = val
                this.searchFun()
            },
            getVoteTypeText(type) {
                const types = {
                    1: '每日免费投票',
                    2: '广告投票',
                    3: '礼物投票'
                }
                return types[type] || '未知'
            }
        }
    }
</script>
<style scoped>
</style>